import { DataTableRequest } from 'components/data-table/types'
import api from 'services/inventory/equipment'

export const handleGetTechnicalStarts = async (request: DataTableRequest) => {
  let res = await api.searchTechnicalStart(request)

  return res?.data ?? []
}
